import {
  useAsyncExecutor,
  useAsyncExecutor2,
  useAsyncExecutorPool,
} from "async-executor-hook";
import { stringify } from "query-string";
import { FC, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  FormControl,
  FormGroup,
  useFormConfig,
  WForm,
  WFormControl,
} from "rectangular-forms";

import {
  WInputText,
  WMultiSelect,
} from "../../common/components/TemplateContainer/InputTemplates";
import { SaveButton } from "../../common/components/TemplateContainer/SaveButton";
import { TemplateInputContainer } from "../../common/components/TemplateContainer/TemplateContainer";
import { getErrorValueResponse } from "../../common/error/Error";
import IconVectorRightBlue from "../../images/icon_button_users_blue.svg";
import IconExcelUsers from "../../images/icon_excel_usuarios.svg";
import { HTTP_METHODS } from "../../utils/constants";
import { networkBackendRequest } from "../../utils/networkUtils";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import { Header, SearchButtonFilter } from "./UsersManagementAdminStyles";
import { ModalProcessingTalma } from "../../common/components/ModalProcessingTalma/ModalProcessingTalma";
import { Authorization } from "../../common/AuthorizationCpt";

interface IUsersManagementAdminSearch {
  params$: any;
  loadUsers: any;
  showEdit: () => void;
}
interface UsersParams {
  user_info: string;
  company_info: string;
  profiles: string[];
  roles: string[];
}
interface DownloadUsersParams {
  formsDownload: UsersParams;
}
const UsersManagementAdminSearch: FC<IUsersManagementAdminSearch> = (props) => {
  const { params$, loadUsers, showEdit } = props;
  const history = useHistory();
  const formConfig = useFormConfig({
    createForm: (data) => {
      const form = new FormGroup({
        company_info: new FormControl(),
        user_info: new FormControl(),
        roles: new FormControl([]),
        profiles: new FormControl([]),
      });
      form.patchValue(data);
      return form;
    },
    onSubmit: (form) => {
      const data = form.value;
      history.push(`/web/admin/users?${stringify(data)}`);
    },
  });
  useAsyncExecutor2((params) => params, {
    params$,
    onSuccess: (params) => {
      formConfig.loadSucceed(params);
    },
  });
  const asyncExecutorPoolRolBackoffice = useAsyncExecutorPool("");
  const loadRolesProfilesBackoffice: any =
    asyncExecutorPoolRolBackoffice.getExecutor("loadRolProfilesUserBackoffice");

  const loadRolesProfilesBackofficeStatus = loadRolesProfilesBackoffice?.status;

  const value = formConfig.form?.get("roles").value || [];

  useEffect(() => {
    if (loadRolesProfilesBackofficeStatus !== "SUCCESS") return;
    const roles = loadRolesProfilesBackoffice.data;

    const rolProfiles = roles
      .filter((rol) => {
        return value.includes(rol.id);
      })
      .flatMap((rol) =>
        rol.profiles.map((profile) => {
          return { ...profile, rol };
        })
      );
    const selectedProfiles = formConfig.form.get("profiles").value || [];
    const filteredProfiles = selectedProfiles.filter((selectedProfile) => {
      return rolProfiles.find(
        (rolProfile) => rolProfile.id === selectedProfile
      );
    });
    formConfig.form.get("profiles").setValue(filteredProfiles);
    setRolProfiles(rolProfiles);

    // eslint-disable-next-line
  }, [loadRolesProfilesBackofficeStatus, value]);

  const [rolProfiles, setRolProfiles] = useState([]);

  const [showErrorReport, setShowErrorReport] = useState<string>("");

  const getDownloadUsers: any = useAsyncExecutor(
    (params: DownloadUsersParams) => {
      const { user_info, company_info, profiles, roles } = params.formsDownload;

      return networkBackendRequest(
        "/reports/users/",
        HTTP_METHODS.POST,
        undefined,
        {
          user_info,
          company_info,
          profiles,
          roles,
        }
      ).then((resp) => resp.json());
    },
    {
      onSuccess: (data) => {
        window.open(data.url);
      },
      onError: (error) => {
        const errorMessage = getErrorValueResponse(error);
        setShowErrorReport(errorMessage);
      },
    }
  );
  return (
    <div>
      <Header>USUARIOS</Header>
      <WForm
        formConfig={formConfig}
        globalErrorMessages={{
          minlength: (val) => {
            return `El valor tiene ${val.actualLength}  ha superado el maximo. Pero debe tener minmo ${val.requiredLength}`;
          },
          maxlength: `Max value`,
        }}
      >
        <div
          className="p-grid"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <div className="p-col-6 p-md-4">
            <WFormControl name="company_info">
              <TemplateInputContainer label="Empresa:">
                <WInputText
                  width="100%"
                  height="5rem"
                  fontSize="1.4rem"
                  placeholder="Razón social o el RUC de la empresa"
                />
              </TemplateInputContainer>
            </WFormControl>
          </div>
          <div className="p-col-6 p-md-4">
            <WFormControl name="user_info">
              <TemplateInputContainer label="Usuario:">
                <WInputText
                  width="100%"
                  height="5rem"
                  fontSize="1.4rem"
                  placeholder="Nombre o número de documento"
                />
              </TemplateInputContainer>
            </WFormControl>
          </div>
          <div className="p-col-6 p-md-4">
            <WFormControl name="roles">
              <TemplateInputContainer
                label="ROL:"
                loadStatus={loadRolesProfilesBackoffice?.status}
              >
                <WMultiSelect
                  options={(loadRolesProfilesBackoffice?.data || []).map(
                    (rol) => {
                      return {
                        name: rol.name,
                        id: rol.id,
                      };
                    }
                  )}
                  width="100%"
                  placeholder="ROL"
                  optionLabel="name"
                  optionValue="id"
                />
              </TemplateInputContainer>
            </WFormControl>
          </div>
        </div>
        <div
          className="p-grid"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <div className="p-col-6 p-md-5">
            <WFormControl name="profiles">
              <TemplateInputContainer
                label="Perfil:"
                loadStatus={loadRolesProfilesBackoffice?.status}
              >
                <WMultiSelect
                  options={
                    (rolProfiles &&
                      rolProfiles.map((profile) => ({
                        name: `${profile.name} de ${profile.rol.name}`,
                        id: profile.id,
                      }))) ||
                    []
                  }
                  width="100%"
                  placeholder="Seleccione Perfil"
                  optionLabel="name"
                  optionValue="id"
                />
              </TemplateInputContainer>
            </WFormControl>
          </div>
          <div
            className="p-col-6 p-md-1"
            style={{
              display: "flex",
              alignItems: "end",
            }}
          >
            <SaveButton
              iconRight={IconVectorRightBlue}
              isLoading={loadUsers.isLoading}
              width="100%"
              height="5rem"
              fontSize="1.5rem"
              backgroundColor="#002E6C"
            />
          </div>
          <div
            className="p-col-6 p-md-3"
            style={{
              display: "flex",
              alignItems: "end",
            }}
          >
            <Authorization actions={["user.get_users_report"]}>
              {loadUsers.isSuccess && (
                <SearchButtonFilter
                  background="white"
                  type="button"
                  width="100%"
                  height="5rem"
                  onClick={() => {
                    getDownloadUsers.execute({
                      formsDownload: formConfig.form.value,
                    });
                  }}
                >
                  <img src={IconExcelUsers} className="icon-excel" alt="" />
                  Descargar reporte
                </SearchButtonFilter>
              )}
            </Authorization>
          </div>
          <div
            className="p-col-6 p-md-3"
            style={{
              display: "flex",
              alignItems: "end",
            }}
          >
            {loadUsers.isSuccess && (
              <SearchButtonFilter
                background="green"
                type="button"
                width="100%"
                height="5rem"
                onClick={() => {
                  showEdit();
                }}
              >
                Crear usuario
              </SearchButtonFilter>
            )}
          </div>
        </div>
      </WForm>

      <ModalProcessingTalma
        showProcessing={getDownloadUsers.status === "PROCESSING"}
      />

      {showErrorReport && (
        <ConfirmationModal
          message={showErrorReport}
          onAccept={() => {
            setShowErrorReport("");
          }}
          title={`Atención`}
          toggleModal={() => {
            setShowErrorReport("");
          }}
        />
      )}
    </div>
  );
};
export default UsersManagementAdminSearch;
